export const getResourceUsage = {"name":"getResourceUsage"}
